import axios from 'axios';
import { PaginatedPriorities } from '../types';

export const fetchPrioritiesList = async (): Promise<PaginatedPriorities> => {
  return (await axios.get(`/v1/priority`)).data;
};
